import { FormProvider } from 'react-hook-form';
import { useEditGroupForm } from './hooks';
import { EditGroupFormPresentation } from './presentations';

type Props = {
  /** 編集対象のグループID */
  groupId: number;
};

/**
 * グループ編集フォームのコンテナコンポーネント
 */
export const EditGroupForm: React.FC<Props> = ({ groupId }) => {
  const {
    state: { methods, isMutating, groupName },
    actions: { handleOnSubmit },
  } = useEditGroupForm(groupId);

  return (
    <FormProvider {...methods}>
      <EditGroupFormPresentation
        groupId={groupId}
        groupName={groupName}
        isButtonDisabled={isMutating}
        onSubmit={handleOnSubmit}
      />
    </FormProvider>
  );
};
